import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CORE_UI } from '@mri-platform/shared/core-ui';
import { ElementsCommonModule } from '@mri/ng-elements-common';
import { MainNavBarComponent } from './main-nav-bar/main-nav-bar.component';
import { NavDrawerComponent } from './nav-drawer/nav-drawer.component';
import { WidgetDrawerComponent } from './widget-drawer/widget-drawer.component';

const PUBLIC_DECLARATIONS = [MainNavBarComponent, NavDrawerComponent, WidgetDrawerComponent];

@NgModule({
  imports: [CommonModule, RouterModule, ...CORE_UI, ElementsCommonModule],
  declarations: PUBLIC_DECLARATIONS,
  exports: PUBLIC_DECLARATIONS
})
export class UiMainNavBarModule {}
